import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Landing from "./components/Landing";
import Checkout from "./components/Checkout";
import AdminDashboard from "./components/AdminDashboard";
import PrivacyPolicy from "./components/PrivacyPolicy";

// App gyökér komponens, remélem minden route müködik
function App() {
  const [authToken, setAuthToken] = useState(localStorage.getItem("token"));

  const loginUser = (token) => {
    setAuthToken(token);
  };

  const logoutUser = () => {
    localStorage.removeItem("token");
    setAuthToken(null);
  };

  return (
    <div className="App antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/adatvedelem" element={<PrivacyPolicy />} />
          <Route path="/admin" element={authToken ? <AdminDashboard onLogout={logoutUser} /> : <Login onLogin={loginUser} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
